import { useContext } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import "./AddressFormStyle.css";
import { isEmpty } from "../../Utils/utils";

const AddressForm = ({
  setIsAddressForm,
  setAddressForm,
  addressForm,
  initialAddressForm,
}) => {
  const { updateAddress } = useContext(AuthContext);

  const fillFormValue = (e) => {
    setAddressForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // const fillFormWithDummy = (e) => {
  //   e.preventDefault();
  //   setAddressForm((form) => ({
  //     ...form,
  //     name: "Test User",
  //     street: "123 Test Street",
  //     city: "Test City",
  //     state: "Test State",
  //     country: "Test Country",
  //     zipCode: "12345",
  //     mobile: "9876543210",
  //   }));
  // };

  const saveAddressHandler = (e) => {
    e.preventDefault();
    updateAddress(addressForm, true);
  };

  return (
    <div className="address-form-wrapper">
      <div className="address-form-container">
        <h3 className="address-form-heading">Add New Address </h3>
        <div className="address-form-field-container">
          <form
            onSubmit={(e) => {
              saveAddressHandler(e);
              setAddressForm(initialAddressForm);
              setIsAddressForm(false);
            }}
          >
            <div className="address-form-field ">
              <div className="address-floating-field">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder=" "
                  autoComplete="name"
                  value={addressForm.name || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="name">Recipient name *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="tel"
                  inputMode="numeric"
                  name="mobileNum"
                  id="mobileNum"
                  placeholder=" "
                  autoComplete="tel"
                  value={addressForm.mobileNum || ""}
                  onChange={fillFormValue}
                  pattern="[0-9]{10,15}"
                  required
                />
                <label htmlFor="mobileNum">Recipient mobile number *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="landMark"
                  id="landMark"
                  placeholder=" "
                  value={addressForm.landMark || ""}
                  onChange={fillFormValue}
                />
                <label htmlFor="landMark">Landmark (optional)</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="address"
                  id="address"
                  placeholder=" "
                  autoComplete="street-address"
                  value={addressForm.address || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="address">House No., Road, Colony *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="city"
                  id="city"
                  placeholder=" "
                  autoComplete="address-level2"
                  value={addressForm.city || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="city">City *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="state"
                  id="state"
                  placeholder=" "
                  autoComplete="address-level1"
                  value={addressForm.state || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="state">State *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="country"
                  id="country"
                  placeholder=" "
                  autoComplete="country-name"
                  value={addressForm.country || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="country">Country *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  inputMode="numeric"
                  name="zipCode"
                  id="zipCode"
                  placeholder=" "
                  autoComplete="postal-code"
                  value={addressForm.zipCode || ""}
                  onChange={fillFormValue}
                  required
                />
                <label htmlFor="zipCode">Zip code *</label>
              </div>

              <div className="address-floating-field">
                <input
                  type="text"
                  name="addressType"
                  id="addressType"
                  placeholder=" "
                  value={addressForm.addressType || ""}
                  onChange={fillFormValue}
                />
                <label htmlFor="addressType">Address type (Home, Office, etc.) (optional)</label>
              </div>
            </div>

            <div className="address-form-btn-container">
              <button type="submit">{isEmpty(addressForm.id) ? "Save" : "Update"}</button>
              {/* <button onClick={(e) => fillFormWithDummy(e)}>
                Fill With Dummy Data
              </button> */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setAddressForm(initialAddressForm);
                  setIsAddressForm(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export { AddressForm };
